import moment from "moment";
// Listing types
import { ListingTypes } from "office/reports/stats/StatsReport";
//-- Colour Constants -------------------------------------------------------------------------------------------------------------------------------
export const _colourAll = "#34ABAB"; //"#4DB3A2";
export const _colourSales = "#4CA852"; //"#D8715D";//"#D8655D";//"#D8715D";
export const _colourRentals = "#578EBE";
export const _colourFeatured = "#8775A7";
export const _colourHd = "#C49F47";
export const _colourFeaturedHd = "#E87E04";
//export const _colourTintAll: string = "#e0f1ee";
//export const _colourTintSales: string = "#fbf1ed";
//export const _colourTintRentals: string = "#dfe6ec";
//export const _colourTintFeatured: string = "#ede2c8";
//export const _colourTintSpotlight: string = "#";
//export const _colourTintSpotlight: string = "#";
export const _colourTintAll = "#fff";
export const _colourTintSales = "#fff";
export const _colourTintRentals = "#fff";
export const _colourTintFeatured = "#fff";
export const _colourTintSpotlight = "#fff";
export const _colourTintHd = "#fff";
export const tintByListingType = (listingType) => {
    switch (listingType) {
        case ListingTypes.Sales: return _colourTintSales;
        case ListingTypes.Rentals: return _colourTintRentals;
        default: return _colourTintAll;
    }
};
//-- Naming Helpers -------------------------------------------------------------------------------------------------------------------------------
const createTotalDescriptor = (descriptor) => {
    return [
        `Total ${descriptor}`,
        `${ListingTypes[ListingTypes.Sales]} ${descriptor}`,
        `${ListingTypes[ListingTypes.Rentals]} ${descriptor}`
    ];
};
const createDescriptorPost = (descriptor) => {
    return [
        `Total ${descriptor}`,
        `${ListingTypes[ListingTypes.Sales]} ${descriptor}`,
        `${ListingTypes[ListingTypes.Rentals]} ${descriptor}`
    ];
};
const createDescriptorPostNoAll = (descriptor) => {
    return [
        `${descriptor}`,
        `${ListingTypes[ListingTypes.Sales]} ${descriptor}`,
        `${ListingTypes[ListingTypes.Rentals]} ${descriptor}`
    ];
};
const createDescriptorPrePost = (descriptorA, descriptorB) => {
    return [
        `${descriptorA} ${descriptorB}`,
        `${descriptorA} ${descriptorB}`,
        `${descriptorA} ${descriptorB}`
    ];
};
// Counts
export const listingTypeTotalLabels = createTotalDescriptor("Listings");
// Leads
export const listingTypeLeadLabels = createDescriptorPost("Leads");
export const listingTypeMessageLeadLabels = createDescriptorPost("Message Leads");
export const listingTypePhoneLeadLabels = createDescriptorPost("Phone Leads");
// Reveals
export const listingTypeRevealLabels = createDescriptorPost("Telephone Reveals Leads");
// Views
export const listingTypeViewLabels = createDescriptorPost("Listings Views");
// Listing On Day Counts
export const listingTypeCountLabels = createDescriptorPost("Listings");
// Averages
export const avgListingTypeViewsLabels = createDescriptorPostNoAll("Listing Performance");
export const avgListingTypeLeadsLabels = createDescriptorPostNoAll("Listing Lead Performance");
export const avgListingTypeStandardViewLabels = createDescriptorPrePost("Standard", "Listing (views per listing per day)");
export const avgListingTypeFeaturedViewLabels = createDescriptorPrePost("Featured", "Listing (views per listing per day)");
export const avgListingTypeHdViewLabels = createDescriptorPrePost("HD", "Listing (views per listing per day)");
export const avgListingTypeFeaturedHdViewLabels = createDescriptorPrePost("Featured & HD", "Listing (views per listing per day)");
export const avgListingTypeStandardLeadLabels = createDescriptorPrePost("Standard", "Listing (leads per listing per day)");
export const avgListingTypeFeaturedLeadLabels = createDescriptorPrePost("Featured", "Listing (leads per listing per day)");
export const avgListingTypeHdLeadLabels = createDescriptorPrePost("HD", "Listing (leads per listing per day)");
export const avgListingTypeFeaturedHdLeadLabels = createDescriptorPrePost("Featured & HD", "Listing (leads per listing per day)");
export const avgListingTypeStandardGraphLabels = ["Standard", "Standard", "Standard"];
export const avgListingTypeFeaturedGraphLabels = ["Featured", "Featured", "Featured"];
export const avgListingTypeHdGraphLabels = ["HD", "HD", "HD"];
export const avgListingTypeFeaturedHdGraphLabels = ["Featured & HD", "Featured & HD", "Featured & HD"];
// Totals
export const totalListingTypeLabels = ["Listings", "Listings", "Listings"]; //createDescriptorPost("Active Listings");
//-- Create Day Series -------------------------------------------------------------------------------------------------------------------------------
export const createDaySeries = (fromDate, toDate) => {
    let daysSeries = [];
    let timeDiff = moment(toDate).diff(moment(fromDate));
    let count = Math.max(1, moment.duration(timeDiff).asDays());
    for (let t = 0; t < count; t++) {
        let dateForLabel = moment(fromDate).add(t, 'days');
        daysSeries.push(dateForLabel.toDate());
    }
    return daysSeries;
};
//-- Create Series Tooltips -------------------------------------------------------------------------------------------------------------------------------
//export const createTooltipDaySeries = (fromDate: Moment.Moment, toDate: Moment.Moment) => {
//    let daysSeries = [];
//    let timeDiff = moment(toDate).diff(moment(fromDate));
//    let count = Math.max(1, moment.duration(timeDiff).asDays());
//    for (let t = 0; t < count; t++) {
//        let dateForLabel = moment(fromDate).add(t, 'days').format("Do MMM YY");
//        daysSeries.push(`<div><b>AHAA ${dateForLabel} </b></div>`);
//    }
//    return daysSeries;
//}
//-- Interweave arrays into Google Charts data structure -------------------------------------------------------------------------------------------------------------------------------
export const interweave = (series) => {
    //-- Merging the seperate arrays into one (needed data shapefor the google graphs)
    // "series" contains data of the form: [[Monday, Tuesday][2.3, 5.9][7.8, 3.4]]
    // "data" (the merged arrays) is of the form [[[Monday][2.3][7.8]],[[Tuesday][5.9][3.4]]]
    let data = [];
    for (let i = 0; i < series[0].length; i++) {
        let dataArray = [];
        for (var j = 0; j < series.length; j++) {
            dataArray.push(series[j][i]);
        }
        data.push(dataArray);
    }
    return data;
};
//-- Google Charts Options Helpers -------------------------------------------------------------------------------------------------------------------------------
export const createDefaultSeriesOptions = (seriesColours) => {
    let seriesOptions = [];
    for (let i = 0; i < seriesColours.length; i++) {
        seriesOptions.push({
            color: seriesColours[i],
            areaOpacity: 0.2
        });
    }
    return seriesOptions;
};
const getAllSeriesMaxValue = (series) => {
    let maxValue = 0;
    if (series && series.length >= 1) {
        for (let i = 0; i < series.length; i++) {
            for (let j = 1; j < series[i].length; j++) {
                const currentValue = series[i][j];
                if (currentValue && currentValue > maxValue) {
                    maxValue = currentValue;
                }
            }
        }
    }
    return maxValue;
};
export const calcVAxisGridlineCount = (series) => {
    // Max values
    let maxValue = getAllSeriesMaxValue(series);
    let maxGridlines = 5;
    if (maxValue <= 5) {
        maxGridlines = maxValue + 1;
    }
    return maxGridlines;
};
//-- Google Charts Series Helpers -------------------------------------------------------------------------------------------------------------------------------
export const findSeriesWithData = (series) => {
    if (series && series.length >= 1) {
        for (let i = 1; i < series[0].length; i++) {
            for (let j = 0; j < series.length; j++) {
                if (series[j][i] !== null) {
                    return true;
                }
            }
        }
    }
    return false;
};
//-- Google Charts hAxis Helpers -------------------------------------------------------------------------------------------------------------------------------
const findAllTimeIncrements = (increment, fromDate, toDate) => {
    let timeSeries = [];
    let dateInQuestion = null;
    //-- Find first date to use
    let minIncrementStart = moment(fromDate).startOf(increment).startOf('day');
    if (minIncrementStart.diff(fromDate, "days") == 0) {
        // fromDate is the same day as the first of the day/week/month
        dateInQuestion = fromDate;
    }
    else {
        // fromDate is NOT the same day as the first of the day/week/month
        // Find fromDate's last day of the day/week/month
        let dateToConsider = moment(fromDate).endOf(increment).add(1, 'day').startOf('day');
        if (dateToConsider.diff(toDate, "days") >= 0) {
            // dateToConsider is not in range (bigger than toDate)
            // Could only happen if a single day was picked... but in that case this is unreachable as the case matches the first if statement
        }
        else {
            // dateToConsider is in range (smaller than toDate)
            dateInQuestion = dateToConsider;
        }
    }
    do {
        // Add the date to our series of dates
        timeSeries.push(dateInQuestion.startOf('day').toDate());
        // Add an increment (day/week/month) to the dateInQuestion
        dateInQuestion = dateInQuestion.add(moment.duration(1, increment)).startOf('day');
        // Stop adding dates if dateInQuestion is out of the given range
    } while (dateInQuestion.diff(toDate, "days") <= 0);
    return timeSeries;
};
export const calcDayTicks = (fromDate, toDate) => {
    fromDate = moment(fromDate).startOf('day');
    toDate = moment(toDate).startOf('day');
    let timeSeries = [];
    let timeDiff = moment(toDate).diff(moment(fromDate));
    let count = Math.max(1, moment.duration(timeDiff).asDays() + 1);
    if (count <= 7) {
        // <= a week, so use 'day' as the increment
        timeSeries = findAllTimeIncrements('day', fromDate, toDate);
    }
    else if (count <= 31) {
        // <= a month, so use 'week' as the increment
        timeSeries = findAllTimeIncrements('week', fromDate, toDate);
    }
    else {
        // > a month, so use 'month' as the increment
        timeSeries = findAllTimeIncrements('month', fromDate, toDate);
    }
    return timeSeries;
};
export const calcMonthTicks = (fromDate, toDate) => {
    fromDate = moment(fromDate).startOf("month");
    toDate = moment(toDate).endOf('month');
    let timeSeries = [];
    let timeDiff = moment(toDate).diff(moment(fromDate));
    let count = Math.floor(Math.max(1, moment.duration(timeDiff).asMonths()));
    let dateIndex = fromDate;
    for (var i = 0; i < count; i++) {
        timeSeries.push(dateIndex.startOf('month').toDate().getMonth() + 1);
        dateIndex = dateIndex.add(1, "month");
    }
    return timeSeries;
};
